import styled from 'styled-components';

import { BasicParagraph, BasicSubtitle, SmallParagraph } from '@genially/design-system';

import { PANEL_SURFACE } from '../../../common/panelColors';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1),
  minHeight: 0,
}));

export const List = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1),
}));

export const AnswerCard = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.unit,
  padding: size.units(2),
  borderRadius: size.units(1),
  backgroundColor: PANEL_SURFACE,
}));

interface IdentityRowProps {
  $isAnonymous: boolean;
}

export const IdentityRow = styled.div<IdentityRowProps>(
  ({ theme: { size }, $isAnonymous }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: size.units(1.5),
    // With no name to sit next to, the date has the row to itself and reads from the end.
    justifyContent: $isAnonymous ? 'flex-end' : 'flex-start',
  }),
);

/** Name over date: next to the avatar they are one block, not two competing columns. */
export const Identity = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const Name = styled(BasicSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const SentAt = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(0.7),
  flexShrink: 0,
}));

export const AnswerText = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
  wordBreak: 'break-word',
}));
